package screens.detail

import common.ECssClasses
import core.AppContext
import core.enums.EImages
import core.extensions.toClassName
import core.ionic.IonCol
import core.ionic.IonContent
import core.ionic.IonGrid
import core.ionic.IonPage
import core.ionic.IonRow
import core.localStorage.LocalStorageDAO
import core.util.ColourHelper
import csstype.AlignContent
import csstype.AlignItems
import csstype.BackgroundColor
import csstype.Display
import csstype.FlexWrap
import csstype.JustifyContent
import csstype.LineStyle
import csstype.NamedColor
import csstype.Position
import csstype.TextAlign
import csstype.minus
import csstype.number
import csstype.pct
import csstype.px
import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import react.dom.html.ReactHTML.b
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span
import react.router.useNavigate
import react.useContext
import react.useState

/**
 * Copyright (c) emgress GmbH. All rights reserved.
 *
 * Created on : 15.11.22
 * Author : leonhergt
 */

external interface ColourToneDetailProps : Props {
}

val ColourToneDetailScreen = FC<ColourToneDetailProps> { props ->

    val mContext by useContext(AppContext)
    val (mLocalStorage, mLocalStorageDispatch) = mContext.mLocalStorageReducer

    val mColourObject by useState(mLocalStorage.mDetailColourObject)
    val closeButtonDisabled by useState(false)

    val mIsColourLight = mColourObject?.let { ColourHelper.getContrastIsBlack(it.mColourCode) }
    val mNavigate = useNavigate()

    IonPage {
        IonContent {
            IonGrid {
                css(
                    classNames = arrayOf(
                        ECssClasses.VERTICAL_GRID.toClassName(),
                        ECssClasses.NON_SCROLLABLE_GRID.toClassName()
                    )
                ) {}
                IonRow {
                    css(ECssClasses.FULL_WIDTH_ROW.toClassName()) {
                        flexGrow = number(1.0)
                    }
                    IonCol {
                        size = "12"
                        css(ECssClasses.FULL_WIDTH_COL.toClassName(), ECssClasses.FLEXBOX_COL.toClassName()) { }
                        div {
                            css {
                                flexGrow = number(1.0)
                                backgroundColor = mColourObject?.mColourCode.unsafeCast<BackgroundColor>()
                            }
                            div {
                                css(ECssClasses.BODY_FONT.toClassName(), ECssClasses.FLEXBOX_COL.toClassName()) {
                                    marginLeft = 20.px
                                    marginTop = 26.px
                                }
                                b {
                                    css {
                                        color = if (mIsColourLight == true) NamedColor.black else NamedColor.white
                                    }
                                    +"${mColourObject?.mArtNr}"
                                }
                                span {
                                    css {
                                        color = if (mIsColourLight == true) NamedColor.black else NamedColor.white
                                    }
                                    +"${mColourObject?.mName}"
                                }
                            }
                        }
                    }
                }
                IonRow {
                    css(ECssClasses.FULL_WIDTH_ROW.toClassName()) {}
                    IonCol {
                        size = "12"
                        css(ECssClasses.FULL_WIDTH_COL.toClassName()) { }
                        div {
                            css(ECssClasses.FLEXBOX_COL.toClassName()) {
                                flexWrap = FlexWrap.wrap
                                justifyContent = JustifyContent.center
                                alignContent = AlignContent.center
                                position = Position.relative
                                paddingTop = 96.px
                                paddingBottom = 36.px
                                paddingLeft = 16.px
                                paddingRight = 16.px
                            }
                            button {
                                css(ECssClasses.ACTION_BUTTON.toClassName()) {
                                    val buttonSize = 72
                                    borderRadius = 50.pct
                                    width = buttonSize.px
                                    height = buttonSize.px
                                    borderWidth = 8.px
                                    borderColor = NamedColor.white
                                    borderStyle = LineStyle.solid
                                    left = 50.pct - (buttonSize / 2).px
                                    top = (-35).px
                                    alignItems = AlignItems.center
                                    position = Position.absolute
                                    display = Display.flex
                                    justifyContent = JustifyContent.spaceAround
                                }
                                onClick = {
                                    mLocalStorageDispatch.invoke(
                                        LocalStorageDAO.ELocalStorageAction.DELETE_DETAIL_COLOUR
                                    )
                                    mNavigate.invoke(-1)
                                    //navigate = EScreens.SHOW_SELECTED_COLOURS.mPath
                                }
                                disabled = closeButtonDisabled
                                img {
                                    css {
                                        height = 26.px
                                        width = 26.px
                                    }
                                    src = EImages.CLOSE_ICON_WHITE.mRelativePath
                                }
                            }
                            ReactHTML.span {
                                css(ECssClasses.BODY_FONT.toClassName()) {
                                    display = Display.flex
                                    justifyContent = JustifyContent.center
                                }
                                +"${mColourObject?.mColourCollection}"
                            }
                            ReactHTML.b {
                                css(ECssClasses.BODY_FONT.toClassName()) {
                                    textAlign = TextAlign.center
                                }
                                +"${mColourObject?.mArtNr} ${mColourObject?.mName}"
                            }
                            ReactHTML.span {
                                css(ECssClasses.BODY_FONT.toClassName()) {
                                    display = Display.flex
                                    justifyContent = JustifyContent.center
                                }
                                +"${mColourObject?.mAdditionalInfo1}"
                            }
                            ReactHTML.span {
                                css(ECssClasses.BODY_FONT.toClassName()) {
                                    display = Display.flex
                                    justifyContent = JustifyContent.center
                                }
                                +"${mColourObject?.mAdditionalInfo2}"
                            }
                        }
                    }
                }
            }
        }
    }
}